<!--====================================
=            TABLEDATATABLE            =
=====================================-->
<template>
  <!-- page blank -->
  <div>
   
      <v-row>
        <base-header>
          <div slot="page-header">Table Database</div>
        </base-header>
      </v-row>
      <v-row>
        <v-col class="col-12 col-md-12 col-sm-12">
          <base-card>
            <div slot="card-header">Selectable rows</div>
            <div slot="card-subheader">The standard data-table will by default render your data as simple rows.

            </div>
            <div slot="card-body">
              <v-data-table  :class="$vuetify.theme.dark ? 'card-light' : 'card-light'" v-model="selected" dark :headers="headers" :items="desserts" :single-select="singleSelect"
                            item-key="name" show-select class="elevation-1 grey--text">
                <template v-slot:top>
                  <v-switch v-model="singleSelect" label="Single select" class="pa-3"></v-switch>
                </template>
              </v-data-table>

            </div>
          </base-card>
        </v-col>

         <v-col class="col-12 col-md-12 col-sm-12">
          <base-card>
            <div slot="card-header">Sort on multiple columns</div>
            <div slot="card-subheader">Using the dense prop you are able to give your data tables an alternate style.
            </div>
            <div slot="card-body">
              <v-data-table   :class="$vuetify.theme.dark ? 'card-light' : 'card-light'" :headers="headers3" dark :items="desserts3" :sort-by="['calories', 'fat']"
                            :sort-desc="[false, true]" multi-sort class="elevation-1 white--text"></v-data-table>

            </div>
          </base-card>
        </v-col>
         <v-col class="col-12 col-md-12 col-sm-12">
          <base-card>
            <div slot="card-header">Group row</div>
            <div slot="card-subheader">You can override the default filtering used with search prop by supplying a
              function to the custom-filter prop. If you need to customize the filtering of a specific column, you can
              supply a function to the filter property on header items. The signature is (value: any, search: string |
              null, item: any) => boolean. This function will always be run even if search prop has not been provided.
              Thus you need to make sure to exit early with a value of true if filter should not be applied.</div>
            <div slot="card-body">
              <v-data-table  :class="$vuetify.theme.dark ? 'card-light' : 'card-light'" dark :headers="headers2" :items="desserts2" item-key="name" group-by="category"
                            class="elevation-1" show-group-by></v-data-table>

            </div>
          </base-card>
        </v-col>
    
   
      
      </v-row>

  </div>
</template>

<script>
  import BaseCard from "../../components/Base/BaseCard.vue";
  import BaseHeader from "../../components/Base/BaseHeader.vue";

  export default {
    components: {
      BaseCard,
      BaseHeader
    },
    data() {
      return {
        search: '',
        singleSelect: false,
        selected: [],
        headers: [{
            text: 'Dessert (100g serving)',
            align: 'start',
            sortable: false,
            value: 'name',
          },
          {
            text: 'Calories',
            value: 'calories'
          },
          {
            text: 'Fat (g)',
            value: 'fat'
          },
          {
            text: 'Carbs (g)',
            value: 'carbs'
          },
          {
            text: 'Protein (g)',
            value: 'protein'
          },
          {
            text: 'Iron (%)',
            value: 'iron'
          },
        ],
        desserts: [{
            name: 'Frozen Yogurt',
            calories: 159,
            fat: 6.0,
            carbs: 24,
            protein: 4.0,
            iron: '1%',
          },
          {
            name: 'Ice cream sandwich',
            calories: 237,
            fat: 9.0,
            carbs: 37,
            protein: 4.3,
            iron: '1%',
          },
         
        ],
        headers2: [{
            text: 'Dessert (100g serving)',
            align: 'start',
            value: 'name',
          },
          {
            text: 'Category',
            value: 'category'
          },
        ],
        desserts2: [{
            name: 'Frozen Yogurt',
            category: 'Ice cream',
          },
          {
            name: 'Ice cream sandwich',
            category: 'Ice cream',
          },
         
        ],
        headers3: [{
            text: 'Dessert (100g serving)',
            align: 'start',
            sortable: false,
            value: 'name',
          },
          {
            text: 'Calories',
            value: 'calories'
          },
          {
            text: 'Fat (g)',
            value: 'fat'
          },
          {
            text: 'Carbs (g)',
            value: 'carbs'
          },
          {
            text: 'Protein (g)',
            value: 'protein'
          },
          {
            text: 'Iron (%)',
            value: 'iron'
          },
        ],
        desserts3: [{
            name: 'Frozen Yogurt',
            calories: 200,
            fat: 6.0,
            carbs: 24,
            protein: 4.0,
            iron: '1%',
          },
          {
            name: 'Ice cream sandwich',
            calories: 200,
            fat: 9.0,
            carbs: 37,
            protein: 4.3,
            iron: '1%',
          },
          
        ],
        headers: [{
            text: 'Dessert (100g serving)',
            align: 'start',
            sortable: false,
            value: 'name',
          },
          {
            text: 'Calories',
            value: 'calories'
          },
          {
            text: 'Fat (g)',
            value: 'fat'
          },
          {
            text: 'Carbs (g)',
            value: 'carbs'
          },
          {
            text: 'Protein (g)',
            value: 'protein'
          },
          {
            text: 'Iron (%)',
            value: 'iron'
          },
        ],
        desserts: [{
            name: 'Frozen Yogurt',
            calories: 200,
            fat: 6.0,
            carbs: 24,
            protein: 4.0,
            iron: '1%',
          },
          {
            name: 'Ice cream sandwich',
            calories: 200,
            fat: 9.0,
            carbs: 37,
            protein: 4.3,
            iron: '1%',
          },
         
        ],

      }
    },
  };
</script>
<!--====  End of TABLEDATATABLE  ====-->